module.exports = __webpack_public_path__ + "img/seriesbanner.7bcda83d.png";